import React, { FC, useMemo } from 'react'

import { TimerVisualizationType, UrgencyTimer, UrgencyTimerProps } from '@Components/UrgencyTimer'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue } from '@Globals/CMS/FieldHelpers'

const getBlockData = (urgencyTimerBlock: Block): UrgencyTimerProps => ({
  endAt: new Date(getJSONFieldValue<string>(urgencyTimerBlock.fields || [], 'endAt') || 0),
  startAt: new Date(getJSONFieldValue<string>(urgencyTimerBlock.fields || [], 'startAt') || 0),
  mainTitle: getJSONFieldValue(urgencyTimerBlock.fields || [], 'mainTitle') || '',
  showCountdown: getJSONFieldValue(urgencyTimerBlock.fields || [], 'showCountdown') || true,
  showTitle: getJSONFieldValue(urgencyTimerBlock.fields || [], 'showTitle') || false,
  subTitle: getJSONFieldValue(urgencyTimerBlock.fields || [], 'subTitle') || '',
  visualizationType: getJSONFieldValue(urgencyTimerBlock.fields || [], 'visualisationType') || TimerVisualizationType.None,
})

interface UrgencyTimerBlockProps {
  id?: string
  urgencyTimerBlock: Block
}

const UrgencyTimerBlock: FC<UrgencyTimerBlockProps> = ({ id, urgencyTimerBlock }) => {
  const {
    endAt,
    mainTitle,
    showCountdown,
    showTitle,
    startAt,
    subTitle,
    visualizationType,
  } = useMemo(() => getBlockData(urgencyTimerBlock), [urgencyTimerBlock])

  return (
    <UrgencyTimer
      endAt={endAt}
      id={id}
      mainTitle={mainTitle}
      showCountdown={showCountdown}
      showTitle={showTitle}
      startAt={startAt}
      subTitle={subTitle}
      visualizationType={visualizationType}
    />
  )
}

export default UrgencyTimerBlock
